import React from 'react';

const ContentBody = ({ children }) => (
	<section className="content">
		{children}
	</section>
)

export default ContentBody;




// WEBPACK FOOTER //
// ./src/areas/shared/components/contentBody/ContentBody.js